import styled from 'styled-components';
import { getPublicPath } from 'utils/paths';
import {
  color,
  container,
  fontSize,
  fontWeight,
  radius,
  screen,
  spacing
} from '../../../theme';
import { Heading1, Heading2, Heading3 } from '../../shared/Typography';

export const StyledHero = styled.div`
  background-color: ${color('navy_700')};
  color: ${color('text_default_inverse')};
`;

export const StyledContainer = styled.div`
  max-width: ${container('md')};
  margin: auto;
  padding-left: ${spacing('md')};
  padding-right: ${spacing('md')};
  padding-bottom: ${spacing('xl3')};

  @media (min-width: ${screen('md')}) {
    padding-bottom: ${spacing('xl5')};
  }

  @media (min-width: ${screen('lg')}) {
    padding-left: 0;
    padding-right: 0;
  }
`;

export const StyledHeader = styled.header`
  background-image: ${() =>
    `url('${getPublicPath('/images/privacyPolicy/hero-bg.svg')}')`};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: left bottom;
  color: ${color('text_white')};

  @media (min-width: ${screen('md')}) {
    background-position: center bottom;
  }

  ${StyledContainer} {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${spacing('lg')};
    padding-top: ${spacing('xl4')};
    padding-bottom: ${spacing('xl')};
    text-align: center;

    @media (min-width: ${screen('md')}) {
      flex-direction: row;
      align-items: flex-start;
      text-align: left;
    }
  }

  ${Heading1} {
    margin-bottom: ${spacing('md')};
  }

  p {
    font-size: ${fontSize('xl2')};
    line-height: 1.14;
    font-weight: ${fontWeight('black')};
    margin: 0;

    @media (max-width: ${screen('mdMax')}) {
      font-size: ${fontSize('lg')};
    }
  }
`;

export const StyledImageComp = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  max-width: 18rem;
  margin-top: -5%;
  margin-bottom: -5%;
  aspect-ratio: 6 / 5;

  @supports not (aspect-ratio: 6 / 5) {
    @media (max-width: ${screen('mdMax')}) {
      height: 15rem;
    }
  }

  img {
    position: absolute;
    inset: 0;
  }
`;

export const StyledIntro = styled.div`
  margin-top: ${spacing('xl3')};
  margin-bottom: ${spacing('xl4')};
  text-align: center;
  font-size: ${fontSize('lg')};
  line-height: 1.6;

  @media (max-width: ${screen('mdMax')}) {
    font-size: ${fontSize('md')};
    line-height: 1.5;
  }

  ${Heading2} {
    margin-bottom: ${spacing('sm')};
    &::before {
      background-color: ${color('sun_900')};
    }
  }
`;

export const StyledLead = styled.p`
  font-size: ${fontSize('xl')};
  line-height: 1.16;
  font-weight: ${fontWeight('black')};
  margin-top: 0;
  margin-bottom: ${spacing('lg')};

  @media (max-width: ${screen('mdMax')}) {
    font-size: ${fontSize('md')};
  }
`;

export const StyledRights = styled.div`
  background-color: ${color('navy_800')};
  padding: 3.5rem 2.5rem 2.5rem;
  border-radius: ${radius('lg')};

  @media (max-width: ${screen('mdMax')}) {
    padding: 2.5rem 1.25rem 1.25rem;
  }

  ${Heading3} {
    text-align: center;
    margin-bottom: ${spacing('lg')};
    &::before {
      background-color: ${color('sun_900')};
    }
  }

  li {
    padding-left: 2rem;
    margin-bottom: ${spacing('lg')};
    position: relative;
    font-weight: ${fontWeight('medium')};
    line-height: 1.25;

    &:last-child {
      margin-bottom: 0;
    }

    &::before {
      content: '';
      position: absolute;
      left: 0;
      width: 1.25rem;
      height: 1.25rem;
      background-image: url("data:image/svg+xml,%3Csvg aria-hidden='true' focusable='false' data-prefix='fal' data-icon='check-circle' class='svg-inline--fa fa-check-circle fa-w-16 ' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' width='24px' height='24px'%3E%3Cpath fill='%23C0BEC9' d='M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 464c-118.664 0-216-96.055-216-216 0-118.663 96.055-216 216-216 118.664 0 216 96.055 216 216 0 118.663-96.055 216-216 216zm141.63-274.961L217.15 376.071c-4.705 4.667-12.303 4.637-16.97-.068l-85.878-86.572c-4.667-4.705-4.637-12.303.068-16.97l8.52-8.451c4.705-4.667 12.303-4.637 16.97.068l68.976 69.533 163.441-162.13c4.705-4.667 12.303-4.637 16.97.068l8.451 8.52c4.668 4.705 4.637 12.303-.068 16.97z'%3E%3C/path%3E%3C/svg%3E%0A");
      background-size: contain;
      background-repeat: no-repeat;
      margin-right: ${spacing('sm')};
      margin-top: 0.1em;
    }
  }

  strong {
    font-weight: ${fontWeight('black')};
  }

  a {
    color: ${color('link_inverse')};

    &:hover {
      color: ${color('link_inverse_hover')};
    }

    &:active {
      color: ${color('link_inverse_active')};
    }
  }
`;
